<template>
<div class="switcher">
	<svg v-if="tableViewRoutes.includes($route.name)" :class="{active: !$store.state.tableView[$route.name]}" width="17" height="17" viewBox="0 0 247 247" xmlns="http://www.w3.org/2000/svg"><g transform="translate(-1958 -410)" ><rect transform="translate(1958 410)" width="116" height="116" rx="8"/><rect transform="translate(1958 541)" width="116" height="116" rx="8"/><rect transform="translate(2089 410)" width="116" height="116" rx="8"/><rect transform="translate(2089 541)" width="116" height="116" rx="8"/></g></svg>
		<toggle-button v-if="tableViewRoutes.includes($route.name)"
			@change="changeView"
			:value="$store.state.tableView[$route.name]"
			:sync="true"
			:speed="0"
			:color="{checked: this.$store.state.dark ? '#616161' : '#c4c4c4', unchecked: this.$store.state.dark ? '#616161' : '#c4c4c4', disabled: '#CCCCCC'}">
		</toggle-button>
	<svg v-if="tableViewRoutes.includes($route.name)" :class="{active: $store.state.tableView[$route.name]}" viewBox="0 0 245 246" width="17" height="17" xmlns="http://www.w3.org/2000/svg"><defs><clipPath id="a"><rect width="245" height="246" fill="none"/></clipPath></defs><g transform="translate(-2247 -411)"><g transform="translate(2247 411)" clip-path="url(#a)"><g transform="translate(-2247 -411)"><rect transform="translate(2335 411)" width="157" height="75" rx="8"/><rect transform="translate(2247 411)" width="75" height="75" rx="8"/></g><g transform="translate(-2247 -326)"><rect transform="translate(2335 411)" width="157" height="75" rx="8"/><rect transform="translate(2247 411)" width="75" height="75" rx="8"/></g><g transform="translate(-2247 -241)"><rect transform="translate(2335 411)" width="157" height="75" rx="8"/><rect transform="translate(2247 411)" width="75" height="75" rx="8"/></g></g></g></svg>
</div>
</template>

<script>
import tableViewRoutes from './../tableViewRoutes';
export default {
    data() {
        return {
            tableViewRoutes
        }
    },
    methods: {
        changeView() {
            this.$store.commit("changeTableView", this.$route.name);
        }
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
.switcher {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	max-width: 110px;
	padding: 0 5px;
	overflow: hidden;

	svg {
		fill: #c4c4c4;

		&.active {
			fill: #3d3df3;
		}

		.dark & {
		fill: $dark-text;

			&.active {
				fill: #3d3df3;
			}
		}
	}

	@media only screen
    and (min-width: 320px)
    and (max-width: 780px) {
    	display: none;
    }
}
</style>
